<template>
<div>
    <div class="row d-flex align-items-center justify-content-center m-0 mt-n1-25rem">
        <div class="col-12">
            <Button @click="$router.push('/buyers')" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-12 my-4">
            <h3 class="c-ndarkthree">
                <span class="bold">Propostas por sacado</span> | {{economicGroup.name}}
            </h3>
        </div>
        <div class="col-12">
            <div class="col-12 mt-4 pl-0" slot="description" >
                <div>
                    <p class="c-ndarkfour bold mb-3">Qual será o modelo de proposta?</p>
                    <el-radio-group v-model="groupRules.modelOffers">
                        <el-radio 
                            :disabled="disabledModeOfferSelect('manual')" 
                            :class="getPrimaryColor"
                            label="manual"
                        >
                            Manual
                        </el-radio>
                        <el-radio
                            :disabled="disabledModeOfferSelect('automatic')"
                            :class="getPrimaryColor"
                            label="automatic"
                        >
                            Automática
                        </el-radio>
                        <el-radio
                            :class="getPrimaryColor"
                            label="blocked"
                        >
                            Bloquear propostas
                        </el-radio>
                    </el-radio-group>
                </div>
                
                <div v-if="groupRules.modelOffers == 'automatic'" class="row mt-2 px-0">

                    <div class="col-12 mt-3 pt-3">
                        <p class="c-ndarkfour bold mb-3">Defina as condições gerais da proposta</p>
                        <!-- <InputText v-model="groupRules.cashbackOperation" label="Cashback (%)" /> -->
                            <div class="d-flex flex-row mb-4">
                                <div class=" mr-4">
                                    <label>IOF</label>
                                    <!-- <Select v-model="groupRules.iof" :items="[{ label: 'Sim', value: true}, { label: 'Não', value: false}]" style="width: 283px;" /> -->
                                    <el-select :popper-class="getPrimaryColor" v-model="groupRules.iof" :class="getPrimaryColor" style="width: 283px;">
                                    <el-option label="Sim" :value="true"></el-option>
                                    <el-option label="Não" :value="false"></el-option>
                                </el-select>
                                </div>
                                <div class="">
                                    <label>Ad Valorem</label>
                                    <!-- <el-input :class="getPrimaryColor" ref="sigleTax" v-model.lazy="singleTax" placeholder="0,12%" v-money="numberFloat"/> -->
                                    <Money class="input-money input-offer" v-model="groupRules.adValorem" v-bind="percentageNumber" />
                                </div>
                            </div>
                            <div class="d-flex flex-row mb-4">
                            <div class=" mr-4">
                                <label>Float</label>
                                <!-- <el-input :class="getPrimaryColor" ref="sigleTax" v-model.lazy="singleTax" placeholder="0,12%" v-money="numberFloat"/> -->
                                <Money class="input-money input-offer" v-model="groupRules.float" v-bind="numberDays" />
                            </div>
                            <div class="">
                                <label>Pagamento</label>
                                <!-- <el-input :class="getPrimaryColor" ref="sigleTax" v-model.lazy="singleTax" placeholder="0,12%" v-money="numberFloat"/> -->
                                <!-- <Money class="input-money input-offer" v-model="groupRules.cashbackOperation" v-bind="percentageNumber" /> -->
                                <el-select :popper-class="getPrimaryColor" v-model="groupRules.daysToPayment" :class="getPrimaryColor" style="width: 283px;">
                                    <el-option label="D + 0" value="0"></el-option>
                                    <el-option label="D + 1" value="1"></el-option>
                                    <el-option label="D + 2" value="2"></el-option>
                                    <el-option label="D + 3" value="3"></el-option>
                                    <el-option label="D + 4" value="4"></el-option>
                                    <el-option label="D + 5" value="5"></el-option>
                                </el-select>
                                <!-- <Select v-model="groupRules.daysToPayment" :items="[{ label: 'D + 0', value: 0}, { label: 'D + 1', value: 1}, { label: 'D + 2', value: 2}, { label: 'D + 3', value: 3}, { label: 'D + 4', value: 4}, { label: 'D + 5', value: 5}]" style="width: 283px;" /> -->
                            </div>
                        </div>
                        <div class="d-flex flex-row mb-4">
                            <div class=" mr-4">
                                <label>Tarifas gerais</label>
                                <!-- <el-input :class="getPrimaryColor" ref="sigleTax" v-model.lazy="singleTax" placeholder="0,12%" v-money="numberFloat"/> -->
                                <Money class="input-money input-offer" v-model="groupRules.tariff" v-bind="money" />
                                <!-- <el-input :class="getPrimaryColor" class="input-money" placeholder="0,00" v-model.lazy="groupRules.tariff" v-money="money">
                                    <span slot="prefix">R$</span>
                                </el-input> -->
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mt-3 pt-3">
                        <p class="c-ndarkfour bold mb-3">Será cobrado tarifas por duplicata?</p>
                        <el-radio-group v-model="haveTarrifPerPortion">
                            <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                            <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                        </el-radio-group>
                        <div v-if="haveTarrifPerPortion" class="d-flex flex-row mt-3">
                            <div class=" mr-4">
                                <label>Tarifa</label>
                                <Money class="input-money input-offer" v-model="groupRules.tariffPerPortion" v-bind="money" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mt-3 pt-3">
                        <p class="c-ndarkfour bold mb-3">Como a taxa será cobrada?</p>
                        <el-radio-group v-model="isSingleTariff">
                            <el-radio :class="getPrimaryColor" :label="true">Única</el-radio>
                            <el-radio :class="getPrimaryColor" :label="false">Por prazo</el-radio>
                        </el-radio-group>
                        <div v-if="isSingleTariff" class="d-flex flex-row mt-3">
                            <div class=" mr-4">
                                <label>Taxa a.m.</label>
                                <Money class="input-money input-offer" v-model="tax" v-bind="percentageNumberTax" />
                            </div>
                        </div>
                        <div v-else>
                            <div class="scroll-box mt-3">
                                    <div v-for="(fare, index) in fareRangeTaxes" :key="index" class="d-flex align-items-center  mt-3 mb-3">
                                    <div class="">
                                        <label>Prazo (dias)</label>
                                        <Money class="input-money width-150" v-model="fare.fareMin" v-bind="number"/>
                                    </div>
                                    <div class="col-1 text-center pt-4">
                                        <p>
                                            até
                                        </p>
                                    </div>
                                    <div class=" align-self-end mr-3">
                                        <label>Prazo (dias)</label>
                                        <Money class="input-money width-150" v-model="fare.fareMax" v-bind="number"/>
                                    </div>
                                    <div class=" mr-3">
                                        <label>Taxa (a.m)</label>
                                        <Money class="input-money width-150" v-model="fare.tax" v-bind="percentageNumberTax"/>
                                    </div>
                                    <div class=" pt-4">
                                        <el-tooltip class="item" content="Excluir linha" placement="bottom">
                                            <span @click="removeTaxRange(fare)">
                                                <Trash />
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                                

                            <div class="col-12 mt-3 pl-0">
                                <Button size="medium" type="outline" @click="addTaxRange" :color="getPrimaryColor">
                                    + Adicionar nova taxa
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3 pt-3">
                        <div class="d-flex flex-row mt-3">
                            <div class=" mr-4">
                                <h6 class="c-ndarkfour regular">Observação</h6>
                                <el-input  type="textarea"  :class="`${getPrimaryColor} custon-textarea width-592`" v-model="groupRules.notes" maxlength="5000"></el-input>
                                <h6 class="c-nmidone regular mt-1">{{ charCount }} caracteres restantes.</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-3 pl-0">
                <Button size="medium" type="" @click="insertOfferRules" :color="getPrimaryColor" :disabled="isLoading">
                    <LoadingBtnDisabled v-if="isLoading"/>
                    <span v-else>Salvar</span>
                </Button>
            </div>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-if="$store.state.user.loading"/>
</div>
</template>

<script>

// Libraries
import { Money } from 'v-money'


import Trash from '@/components/icons/Trash'


// Components
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import FullLoading from '@/components/loading/FullLoading'
import LoadingBtnDisabled from '@/assets/imgs/icons/LoadingBtnDisabled.vue'

import { getAutoOfferRules, updateAutoOfferRules } from '@/api/autoOffer.js'
import updateEconomicGroupSponsor from '@/api/updateEconomicGroupSponsor.js'

const FARE_RANGE = [
    {
        fareMin: '1',
        fareMax: '2',
        tax: 2.1
    },
    {
        fareMin: '2',
        fareMax: '3',
        tax: 2.11
    },
    {
        fareMin: '3',
        fareMax: '4',
        tax: 2.12
    }
]

export default {
    components: {
        ArrowDropdown,
        Money,
        FullLoading,
        Trash,
        LoadingBtnDisabled,
    },
    data() {
        return {
            economicGroup: {

            },
            percentageNumber: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                suffix: '%',
                masked: false
            },
            percentageNumberTax: {
                decimal: ',',
                thousands: '.',
                precision: 7,
                suffix: '%',
                masked: false
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
            },
            number: {
                // decimal: ',',
                // thousands: '.',
                // prefix: 'R$ ',
                precision: 0,
            },
            numberDays: {
                suffix: ' dias',
                precision: 0,
            },
            groupRules: {
                modelOffers: '',
                iof: false,
                adValorem: 0,
                float: 0,
                daysToPayment: '0',
                tariff: 0,
                tariffPerPortion: 0,
                taxes: [],
                notes: '',
            },
            tax: 0,
            fareRangeTaxes: FARE_RANGE,
            haveTarrifPerPortion: false,
            isSingleTariff: true,
            dialogVisible: false,
            isLoading: false,
        }
    },
    directives: {
        money: Money
    },
    computed: {
        groupName() {
            return this.$store.state.group.groups.find(group => group.id == this.$route.params.groupId).name
        },
        charCount() {            
            return 5000 - (this.groupRules.notes.length || 0)
        },
    },
    watch: {
        fareRangeTaxes() {
            if (this.fareRangeTaxes.length <= 1) {
                this.isSingleTariff = true
                this.fareRangeTaxes = FARE_RANGE
            }
        }
    },
    methods: {
        addTaxRange() {
            const fareRangesLength = this.fareRangeTaxes.length - 1
            const lastFareMax = parseInt(this.fareRangeTaxes[fareRangesLength].fareMax)
            const lastTax = parseFloat(this.fareRangeTaxes[fareRangesLength].tax)
            // log
            this.fareRangeTaxes.push({
                fareMin: ((lastFareMax + 1)).toString(),
                fareMax: ((lastFareMax + 2)).toString(),
                tax: ((lastTax + 0.01).toFixed(7)).toString()
            })
        },
        disabledModeOfferSelect(status) {
            const { modelOffers, dataImportType } = this.economicGroup.economicGroupRule
            if (modelOffers == 'both' || modelOffers == status) return false
            if (status === 'automatic' && dataImportType === 'buyerValidation') return true
            return true
        },
        removeTaxRange(fareRange) {
            const fareRangeToRemove = this.fareRangeTaxes.find(range => range.fareMin == fareRange.fareMin && range.fareMax == fareRange.fareMax && range.tax == fareRange.tax)
            this.fareRangeTaxes = this.fareRangeTaxes.filter(range => range !== fareRangeToRemove )
        },
        async insertOfferRules() {
            this.isLoading = true;
            const updateModelOffer = await updateEconomicGroupSponsor(this.$route.params.economicGroupId, { modelOffers: this.groupRules.modelOffers })
            if (this.groupRules.modelOffers == 'automatic') {
                const taxes = this.fareRangeTaxes.map((data) => {
                    return { ...data, tax: (data.tax / 100) }
                })
                const update = await updateAutoOfferRules(this.$route.params.economicGroupId, {
                    iof: this.groupRules.iof,
                    adValorem: (this.groupRules.adValorem / 100).toFixed(4),
                    float: parseInt(this.groupRules.float),
                    daysToPayment: this.groupRules.daysToPayment,
                    tariff: Math.round(parseFloat(this.groupRules.tariff) * 100),
                    tariffPerPortion: this.haveTarrifPerPortion ? Math.round(parseFloat(this.groupRules.tariffPerPortion) * 100) : 0,
                    taxes: this.isSingleTariff ? [{fareMin: '0', fareMax: '1000', tax: (this.tax / 100)}] : taxes,
                    notes: this.groupRules.notes,
                })
                if (update.data.ok) {
                    const notifyTitle = 'Alterações salvas com sucesso!'
                    this.$notify({
                        title: notifyTitle,
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                    })
                    this.$router.push(`/buyers`)
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            } else {
                if (updateModelOffer.data.ok) {
                    const notifyTitle = 'Alterações salvas com sucesso!'
                    this.$notify({
                        title: notifyTitle,
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                    })
                    this.$router.push(`/buyers`)
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            }
            this.isLoading = false;
        },
    },
    async created() {
        this.economicGroup = this.$store.state.group.groups.find((economicGroup) => economicGroup.id == this.$route.params.economicGroupId)
        if (!this.economicGroup) this.$router.push('/404')

        this.groupRules.modelOffers = this.economicGroup.sponsors[0].economicGroupSponsor.modelOffers

        const dataAutoOfferRules = await getAutoOfferRules(this.$route.params.economicGroupId)
        if (dataAutoOfferRules) {
            const {
                iof,
                adValorem,
                float,
                daysToPayment,
                tariff,
                tariffPerPortion,
                autoOfferFareRangeTaxes,
                notes,
            } = dataAutoOfferRules
            const formatedTaxes = autoOfferFareRangeTaxes.map((tax) => {
                return { ...tax, tax: (parseFloat(tax.tax) * 100).toFixed(7) }
            })
            this.groupRules = {
                ...this.groupRules,
                iof,
                adValorem: (parseFloat(adValorem) * 100).toFixed(2),
                float: parseInt(float),
                daysToPayment,
                tariff: (parseInt(tariff) / 100).toFixed(2),
                tariffPerPortion: (parseInt(tariffPerPortion) / 100).toFixed(2),
                notes,
            },
            this.tax = formatedTaxes.length == 1 ? formatedTaxes[0].tax : 0
            this.fareRangeTaxes = formatedTaxes.length > 1 ? formatedTaxes : FARE_RANGE
            this.haveTarrifPerPortion = tariffPerPortion > 0 ? true : false
            this.isSingleTariff = formatedTaxes.length == 1 ? true : false
        }
    },
    destroyed() {
    }

}
</script>

<style lang="scss">
.input-offer {
    width: 283px!important
}

.width-592 {
    width: 592px;
}

.width-150 {
    width: 150px;
}

.scroll-box {
    width: 592px;
    height: 264px;
    overflow-y: scroll;
}

.custon-textarea textarea {
    height: 131px!important;
}

</style>
